import { API_BASE_URL, performTokenRefresh } from "@repo/api";
import type { HostConfig } from "./hostConfig";

export interface AgentHostConfig extends HostConfig {}

const isDev = import.meta.env.DEV;

export function getAgentHostConfig(
  onNavigate?: (path: string) => void,
): AgentHostConfig {
  const apiBaseUrl = isDev
    ? `${window.location.origin}/api-proxy`
    : (import.meta.env.VITE_API_BASE_URL as string) || window.location.origin;

  return {
    basename: "/agent",
    apiBaseUrl,
    hostName: "standalone-ui",
    onUnauthorized: () => performTokenRefresh(API_BASE_URL),
    onNavigate,
  };
}
